import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import './SkeletonLoader.css';

// Skeleton para Stats Cards
export const StatsCardSkeleton = ({ count = 6 }) => (
    <Row className="g-3 mb-3">
        {Array.from({ length: count }).map((_, i) => (
            <Col md={count === 4 ? 3 : 2} sm={6} key={i}>
                <Card className="h-100 shadow-sm border-0">
                    <Card.Body>
                        <div className="skeleton skeleton-text mb-2" style={{ width: '60%', height: '12px' }}></div>
                        <div className="skeleton skeleton-text" style={{ width: '80%', height: '32px' }}></div>
                    </Card.Body>
                </Card>
            </Col>
        ))}
    </Row>
);

// Skeleton para Charts
export const ChartSkeleton = ({ title }) => (
    <Card className="shadow-sm border-0">
        <Card.Header className="bg-white border-bottom">
            <div className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fw-bold">{title || 'Cargando...'}</h6>
                <div className="skeleton skeleton-text" style={{ width: '200px', height: '20px' }}></div>
            </div>
        </Card.Header>
        <Card.Body>
            <div className="skeleton skeleton-chart" style={{ width: '100%', height: '300px' }}></div>
        </Card.Body>
    </Card>
);

// Skeleton para Tables
export const TableSkeleton = ({ rows = 5 }) => (
    <Card className="shadow-sm border-0">
        <Card.Header className="bg-white border-bottom">
            <div className="skeleton skeleton-text mb-2" style={{ width: '200px', height: '24px' }}></div>
            <Row className="g-2">
                {[1, 2, 3, 4].map(i => (
                    <Col md={3} key={i}>
                        <div className="skeleton skeleton-text" style={{ width: '100%', height: '32px' }}></div>
                    </Col>
                ))}
            </Row>
        </Card.Header>
        <Card.Body className="p-0">
            <div className="table-responsive">
                <table className="table table-hover mb-0">
                    <thead className="bg-light">
                        <tr>
                            {[1, 2, 3, 4, 5].map(i => (
                                <th key={i}>
                                    <div className="skeleton skeleton-text" style={{ width: '80%', height: '16px' }}></div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: rows }).map((_, i) => (
                            <tr key={i}>
                                {[1, 2, 3, 4, 5].map(j => (
                                    <td key={j}>
                                        <div className="skeleton skeleton-text" style={{ width: '90%', height: '14px' }}></div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card.Body>
    </Card>
);

TableSkeleton.propTypes = {
    rows: PropTypes.number
};

StatsCardSkeleton.propTypes = {
    count: PropTypes.number
};

ChartSkeleton.propTypes = {
    title: PropTypes.string
};
